import { AvatarProps, Stack, Typography } from "@mui/material";
import React, { FC, ReactNode } from "react";
import { CompanyAvatar } from "./CompanyAvatar";
import { CompanyContactInfo } from "./CompanyContactInfo";
import { CompanyRegistrationInfo } from "./CompanyRegistrationInfo";
import { CompanyStats } from "./CompanyStats";
import { CompanyStatusChip } from "./CompanyStatusChip";
import { CompanyHeaderFragment } from "./fragments.types";

interface CompanyHeaderProps {
  company: CompanyHeaderFragment;
  actions?: ReactNode;
  avatarSize?: AvatarProps["size"];
}

/**
 * Profile card of a company: avatar, status, name, registration identifiers, contact details
 * and - when the query selected them - the invoice and order totals. Every block renders only
 * from the props it was given, so the same component serves both a full detail view and the
 * hover tooltip.
 */
export const CompanyHeader: FC<CompanyHeaderProps> = ({ company, actions, avatarSize }) => (
  <Stack direction="row" spacing={1} sx={{ alignItems: "start", pb: 0.5 }}>
    <CompanyAvatar company={company} size={avatarSize} />
    <Stack direction="column">
      <Stack direction="column" gap={0.25}>
        <Typography sx={{ display: "inline-block", fontSize: "17px", fontWeight: 500, lineHeight: "20px" }}>
          {company.name}
        </Typography>
        <CompanyStatusChip status={company.status} />
      </Stack>
      <CompanyStats company={company} />
      <CompanyRegistrationInfo company={company} />
      <CompanyContactInfo company={company} />
    </Stack>
    {actions}
  </Stack>
);
